export const sampleMemories = [
  {
    id: 'mem-001',
    agentId: 'agent-alice',
    type: 'task_progress',
    content: 'Completed Phase 2 of database migration — all user tables moved to new schema. Phase 3 involves updating API endpoints.',
    importance: 0.9,
    tags: ['database', 'migration', 'phase-2'],
    sessionId: 'sess-001',
    createdAt: new Date(Date.now() - 3600000 * 2).toISOString(),
    score: 0.92,
  },
  {
    id: 'mem-002',
    agentId: 'agent-alice',
    type: 'context',
    content: 'User prefers YAML config files over JSON. Always output config in YAML format unless explicitly requested.',
    importance: 0.7,
    tags: ['preference', 'config', 'yaml'],
    sessionId: 'sess-001',
    createdAt: new Date(Date.now() - 3600000 * 24).toISOString(),
    score: 0.85,
  },
  {
    id: 'mem-003',
    agentId: 'agent-bob',
    type: 'tool_result',
    content: 'Code review: Found 3 security vulnerabilities in auth module — SQL injection in user query, exposed JWT secret in logs, missing rate limiting.',
    importance: 0.95,
    tags: ['security', 'review', 'auth'],
    sessionId: 'sess-002',
    createdAt: new Date(Date.now() - 3600000 * 5).toISOString(),
    score: 0.88,
  },
  {
    id: 'mem-004',
    agentId: 'agent-alice',
    type: 'task_progress',
    content: 'API endpoints for auth service now updated to new schema. Pending: migration validation tests and load testing.',
    importance: 0.8,
    tags: ['database', 'api', 'phase-3'],
    sessionId: 'sess-001',
    createdAt: new Date(Date.now() - 3600000).toISOString(),
    score: 0.90,
  },
  {
    id: 'mem-005',
    agentId: 'agent-bob',
    type: 'conversation',
    content: 'User requested weekly status reports via email. Set up automated report generation every Friday at 9am.',
    importance: 0.6,
    tags: ['automation', 'reports', 'email'],
    sessionId: 'sess-002',
    createdAt: new Date(Date.now() - 7200000).toISOString(),
    score: 0.75,
  },
];
